import api, { authService } from './api';

export const dataService = {
  listRows: async (tableName, options = {}) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const params = {
        limit: options.limit || 50,
        offset: options.offset || 0,
      };
      if (options.latest) {
        params.latest = true;
      }
      if (options.sortBy) {
        params.sort_by = options.sortBy;
        params.sort_dir = options.sortDir || 'asc';
      }

      const response = await api.get(`/tables/${tableName}/rows`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      });

      return {
        success: true,
        rows: response.data.data || [],
        totalCount: response.data.total_count || 0,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch table rows',
      };
    }
  },

  insertRow: async (tableName, rowData) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.post(`/tables/${tableName}/rows`, { data: rowData }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        result: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to insert row',
      };
    }
  },

  deleteRow: async (tableName, rowId) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.delete(`/tables/${tableName}/rows/${rowId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        result: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to delete row',
      };
    }
  },
};
